import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

const parseErrorCode = error => {
  const status = error?.response?.status;

  // 处理 401 Unauthorized 错误（手动暂停、账户过期或认证失效）
  // 清除登录状态并跳转到登录页
  if (status === 401) {
    clearCookiesOnLogout();
  }

  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
